import React, { useState, useEffect, useRef } from 'react';
import { Flex, Heading, Stack, Text, Box, Button, HStack, VStack, useToast, Spinner } from '@chakra-ui/react';
import { FaUserCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import axios from "axios";
import CustomFormInput from "../components/FormInputFields";
import CommonVars from "../components/CommonVars";

function ProfileScreen () {
    const userid = parseInt(useParams().userid);
    if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')).role === null) {
        window.location.replace("/unauthorized");
    }
    const theToken = localStorage.getItem('token');
    const isAdmin = JSON.parse(localStorage.getItem('userDetails')).role;
    const [userInfo, setUserInfo] = useState('');
    const errRef = useRef();
    const successRef = useRef();
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [discountCodes, setDiscountCodes] = useState('');
    const [loading, setLoading] = useState(false);

    // access backend to retrieve user detail entered when sign up
    const getUserInfo = async () => {
        axios.get(`${CommonVars.API_URL}/users/${userid}/`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setUserInfo(res.data[0]);
            setLoading(true);
        })
        .catch((error) => {
            console.log(error);
            if(error.response.status === 401) {
                window.location.replace("/unauthorized");
            }
        })
    }

    // access backend to retrieve all users discount codes
    const getUserDiscounts = async () => {
        axios.get(`${CommonVars.API_URL}/user/${userid}/discounts`, { headers: { Authorization: `Bearer ${theToken}` } })
        .then((res) => {
            setDiscountCodes(res.data);
            setLoading(true)
        })
        .catch((error) => {
            console.log(error);
        })
    }

    // set logout toast message
    const logoutToast = useToast();
    const id = 'logout-toast';

    // to log user out
    const logoutUser = (event) => {
        event.preventDefault();
        if(!logoutToast.isActive(id)) {
            logoutToast({
                id,
                title: 'Logged Out!',
                description: "Account logged out sucessfully!",
                status: 'success',
                position: 'top',
                duration: 2000,
                isClosable: true,
            });
        }
        setTimeout(() => {
            window.location.replace("/login");
            // remove local storage items
            localStorage.removeItem('token');
            localStorage.removeItem('userDetails');
        }, 2000);
        
    }

    const adminPageDirect = () => {
        window.location.replace("/admin");
    }

    useEffect(() => {
        getUserInfo();
        getUserDiscounts();
    });

    const userDiscounts = [];
    for (let i=0; i < discountCodes.length; i++) {
        userDiscounts.push(
            <Box
                key={discountCodes[i].discountid}
                borderBottomWidth={1}
                borderStyle={'solid'}
                borderColor={'gray.200'}
                pt={4}
            >
                <HStack justify={'space-between'} pb={3}>
                    <VStack align={'flex-start'}>
                        <Text>Discount Code</Text>
                        <Text>{discountCodes[i].discount_code}</Text>
                    </VStack>
                    <VStack align={'flex-end'}>
                        <Text>Earned on</Text>
                        <Text>{discountCodes[i].date}</Text>
                    </VStack>
                </HStack>
            </Box>
        )
    }

    return (
        <Formik
            initialValues={{
                username: '',
                fullname: '',
                email: '',
            }}
            validationSchema={Yup.object({
                username: Yup.string()
                .min(4, 'New username must be at least 4 characters long'),
                email: Yup.string()
                .email('Invalid Email Address'),
            })}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                let newUsername = values.username;
                let newFullname = values.fullname;
                let newEmail = values.email;
                // check if there are new inputs to the fields
                // else use existing values
                if (newUsername === "") {
                    newUsername = userInfo.username;
                }
                if (newFullname === "") {
                    newFullname = userInfo.fullname;
                }
                if (newEmail === "") {
                    newEmail = userInfo.email;
                }
                // prepare the request body for user profile update
                const upProfileRequestBody = {
                    username: newUsername,
                    fullname: newFullname,
                    email: newEmail
                };
                // access backend to update user profile details
                axios.put(`${CommonVars.API_URL}/users/${userid}`, upProfileRequestBody, {
                    headers: { Authorization: `Bearer ${theToken}` },
                })
                .then((res) => {
                    console.log(res);
                    setSuccessMsg('Account details updated successfully!');
                    resetForm();
                    setSubmitting(false);
                    setTimeout(() => {
                        window.location.reload();
                    }, 2000)
                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        setErrMsg('Username or Email is already Taken.');
                        setTimeout(() => {
                            setErrMsg();
                            console.clear();
                        }, 3000)
                    }
                    setSubmitting(false);
                })
            }}
        >
            {props => (
                <Flex 
                    minH={'100vh'}
                    align={'center'}
                    justify={'center'}
                    bg={'#F4F4F4'}
                >
                    {loading !== true ? 
                        <Flex align={'center'} justify={'center'}>
                            <VStack align="center">
                                    <Spinner thickness='9px' speed='0.75s' emptyColor='gray.200' color='blue.500' boxSize={24}/>
                                    <Text fontSize={18} pt={6}>Loading Profile...</Text>
                            </VStack>
                        </Flex> : 
                        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
                            <Stack align={'center'}>
                                <HStack>
                                    <Heading fontSize={'4xl'}>Hello </Heading>
                                    <Heading>{userInfo.username}!</Heading>
                                </HStack>
                                <Text fontSize={'lg'} color={'gray.600'}>
                                    Good to see you again. Welcome back to the store!
                                </Text>
                            </Stack>
                            <Box
                                rounded={'lg'}
                                bg={'white'}
                                boxShadow={'lg'}
                                p={8}
                            >
                                <Box
                                    borderBottomWidth={1}
                                    borderStyle={'solid'}
                                    borderColor={'gray.200'}
                                    pb={4} 
                                >
                                    <HStack justify={'space-between'}>
                                        <FaUserCircle size={80}/>
                                        <HStack spacing={4}>
                                            {isAdmin !== "admin" ? null : <Button onClick={adminPageDirect}>Admin</Button>}
                                            <Button onClick={logoutUser}>Logout</Button>
                                        </HStack>
                                    </HStack>
                                    <HStack pt={4}>
                                        <Text color={'gray.600'}>Joined on: </Text>
                                        <Text color={'gray.600'}>{userInfo.date}</Text>
                                    </HStack>
                                </Box>
                                <Form>
                                    <Stack spacing={2} pt={4} pb={10}>
                                        <Text fontSize={20} fontWeight={'bold'}>User Profile Edit</Text>
                                        <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"}>{errMsg}</p>
                                        <p ref={successRef} className={successMsg ? "successmsg" : "offscreen"}>{successMsg}</p>
                                        {/* Username Input */}
                                        <CustomFormInput
                                            label="Username" 
                                            name="username" 
                                            type="text"
                                            placeholder={`${userInfo.username}`}
                                        />
                                        {/* Fullname Input */}
                                        <CustomFormInput
                                            label="Full Name" 
                                            name="fullname" 
                                            type="text"
                                            placeholder={`${userInfo.fullname}`}
                                        />
                                        {/* Email Input */}
                                        <CustomFormInput
                                            label="Email" 
                                            name="email" 
                                            type="text"
                                            placeholder={`${userInfo.email}`}
                                        />
                                        <HStack pt={4}>
                                            <Button
                                                type="submit"
                                                bg={'black'}
                                                color={'white'}
                                                _hover={{
                                                bg: '#37404A',
                                                }}
                                            >
                                                {props.isSubmitting ? 'Updating...' : 'Update Profile'}
                                            </Button>
                                            <Button type='reset'>Reset</Button>
                                        </HStack>
                                    </Stack>
                                </Form>
                                <Box 
                                    borderTopWidth={1}
                                    borderStyle={'solid'}
                                    borderColor={'gray.200'}
                                >
                                    <Text fontSize={20} fontWeight={'bold'} pt={3}>My Discount Codes</Text>
                                    {userDiscounts}
                                </Box>
                            </Box>
                        </Stack> 
                        }
                </Flex>
            )}
        </Formik>
    );
}

export default ProfileScreen;
